export default __webpack_public_path__ + "static/media/redo.d20cb456.png";